"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../../components/theme");
exports.CSS = {
    container: 'c-CollectionMetaInfo',
    item: 'c-CollectionMetaInfo__Item',
    name: 'c-CollectionMetaInfo__Name',
    value: 'c-CollectionMetaInfo__Value',
    link: 'c-CollectionMetaInfo__Link'
};
exports.Style = {
    [exports.CSS.container]: {
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'box-shadow': theme_1.DefaultTheme.shadow.box.bottom
    },
    [exports.CSS.item]: {
        display: 'flex',
        'justify-content': 'space-between',
        padding: theme_1.DefaultTheme.space(1) + ' ' + theme_1.DefaultTheme.space(2)
    },
    [exports.CSS.value]: {
        color: theme_1.DefaultTheme.font.color.supporting
    }
};
//# sourceMappingURL=collection.meta.info.style.js.map